import ScrollWatcher from './ScrollWatcher';

/**
 * Creates an Infinite Scroll area - use a loading spinner or similar
 */
export default class InfiniteScrollPlaceholder {
  constructor(
    private doc: Document,
    private markup: string,
    private threshold: number
  ) {}

  /**
   * Places the markup in the document and adds the appropriate event
   */
  public createElement(cb: () => void): HTMLElement {
    const el = this.doc.createElement('div');
    el.innerHTML = this.markup;
    const watcher = new ScrollWatcher(el, this.threshold);
    watcher.watch(cb);
    return el;
  }
}
